import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Checkbox from '../../../../common/Checkbox';
import { DELIVERY_INFO_MODS, DELIVERY_SELECT_MOCK } from '../../../../../config';
import InputWrapper from '../../../../common/InputWrapper';
import Button from '../../../../common/Button';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCreateOrEditDeliveryItem, fetchGetDeliveryList } from '../../../../../actions/admin';
import SelectComponent from '../../../../common/Select';
import mu from 'prettier/esm/parser-markdown.mjs';
import { toast } from 'react-toastify';
import { parseError } from '../../../../../helpers';

const Wrapper = styled('div')`
  .text-center {
    width: 100%;
    text-align: center;
  }

  .table .thead-light th:nth-child(n + 2) {
    text-align: center !important;
  }

  .flex-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 16px;
    margin-top: 10px;
  }
`;

const validationSchema = Yup.object().shape({
  correctionType: Yup.string().required('Укажите тип корректировки'),
  warehouseId: Yup.string().required('Укажите склад'),
});

const fbmTypeOptions = [
  { label: 'Озон', value: 'OZON' },
  { label: 'Вайлдберриз', value: 'WILDBERRIES' },
  { label: 'Яндекс Маркет', value: 'YANDEX_MARKET' },
  { label: 'Ламода', value: 'LAMODA' },
  { label: 'Летуаль', value: 'LETOILE' },
  { label: 'Золотое Яблоко', value: 'ZOLOTOE_YABLOKO' },
  { label: 'Фбо b2b', value: 'FBO_B2B' },
  { label: 'Детский мир', value: 'DET_MIR' },
  { label: 'Все инструменты', value: 'VSEINSTRUMENTI' },
  { label: 'Мвидео', value: 'MVIDEO' },
  { label: 'Мегамаркет', value: 'MEGAMARKET' },
  { label: 'Магнит', value: 'MAGNIT' },
  { label: 'Ретейл', value: 'RETAIL_NETWORK' },
];

const Info = (props) => {
  const { handleSwitchMode, mode, item, services } = props;
  const dispatch = useDispatch();
  const [products, setProducts] = useState(null);

  const formik = useFormik({
    initialValues: {
      active: item.active || false,
      code: item.code || null,
      courierCode: item.courierCode || '',
      courierTitle: item.courierTitle || '',
      productCode: item.deliveryCompanyProduct || item.productCode || null,
      product: item.deliveryCompanyProductName || item.product || null,

      deliveryCode: item.deliveryCode || '',
      deliveryType: item.deliveryType || '',
      title: item.title || '',
      type: item.type || null,

      fboDeliveryByCactus: item.fboDeliveryByCactus || false,
      publicAvailable: item.publicAvailable || false,
      marketplace: item.marketplace || false,
      fbmType: item.fbmType || null,
      contractNumber: item.contractNumber || null,
    },
    enableReinitialize: true,
    validationSchema,
  });

  const { values, errors, submitCount, handleChange, setFieldValue } = formik;

  const handleSubmit = () => {
    dispatch(fetchCreateOrEditDeliveryItem(values, 'EDIT'))
      .then(() => {
        toast.info('Информация о доставке сохранена');
        handleSwitchMode(DELIVERY_INFO_MODS.LIST);
      })
      .catch((err) => {
        toast.error(parseError(err));
      });
  };

  const handleSetCompany = (value) => {
    setFieldValue('courierCode', value?.value || null);
    setFieldValue('courierTitle', value?.label || null);

    const newProducts =
      value?.products?.map((item) => {
        return {
          value: item.deliveryCompanyProduct,
          label: item.deliveryCompanyProductName,
        };
      }) || [];

    setProducts(newProducts);
    setFieldValue('productCode', null);
    setFieldValue('product', null);
  };

  const handleSetProducts = (value) => {
    setFieldValue('productCode', value?.value || null);
    setFieldValue('product', value?.label || null);
  };

  const handleSetType = (value) => {
    setFieldValue('deliveryType', value.value);
  };

  const handleSetFbmType = (value) => {
    setFieldValue('fbmType', value.value);
  };

  const findElement =
    DELIVERY_SELECT_MOCK.find((item) => item.value === values.deliveryType)?.label || null;

  const findFbmTypeElement =
    fbmTypeOptions.find((item) => item.value === values.fbmType)?.label || null;

  return (
    <Wrapper>
      <form>
        <div className="flex-wrapper">
          {mode === DELIVERY_INFO_MODS.INFO && (
            <Button
              type="button"
              text="&#8592; Назад к списку доставок"
              onClick={() => handleSwitchMode(DELIVERY_INFO_MODS.LIST)}
            />
          )}
          {mode === DELIVERY_INFO_MODS.EDIT && (
            <>
              <Button
                type="button"
                text="&#8592; Отменить изменения и вернуться к списку"
                onClick={() => handleSwitchMode(DELIVERY_INFO_MODS.LIST)}
              />
              <Button type="button" text="Сохранить изменения" onClick={() => handleSubmit()} />
            </>
          )}
        </div>

        <div className="form-group" style={{ marginTop: '18px' }}>
          <div className="row">
            <div className="col-6">
              <InputWrapper /*Название*/
                label="Название договора"
                id="title"
                value={values.title}
                onChange={(e) => setFieldValue('title', e.target.value)}
                isDisabled={mode === DELIVERY_INFO_MODS.INFO}
              />
            </div>
            <div className="col-6">
              <SelectComponent /*Тип */
                label="Тип"
                options={DELIVERY_SELECT_MOCK}
                value={{
                  value: values.deliveryType,
                  label: findElement,
                }}
                onChange={(value) => handleSetType(value)}
                isClearable={false}
                isDisabled={mode === DELIVERY_INFO_MODS.INFO}
              />
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: 'flex-end' }}>
            {services !== null && (
              <div className="col-6">
                <SelectComponent /*Название КС*/
                  label="Название КС"
                  options={services}
                  value={{
                    value: values.courierCode,
                    label: values.courierTitle,
                  }}
                  onChange={(value) => handleSetCompany(value)}
                  isClearable
                  isDisabled={mode === DELIVERY_INFO_MODS.INFO}
                  isSearchable
                />
              </div>
            )}
            <div className="col-6">
              <InputWrapper /*Тип доставки*/
                label="Код КС"
                id="courierCode"
                value={values.courierCode}
                onChange={(e) => setFieldValue('courierCode', e.target.value)}
                isDisabled={true}
              />
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: 'flex-end' }}>
            <div className="col-6">
              <SelectComponent
                label="Продукт"
                options={products || []}
                onChange={(value) => handleSetProducts(value)}
                isClearable={true}
                isDisabled={mode === DELIVERY_INFO_MODS.INFO}
                value={{
                  value: values.productCode,
                  label: values.product,
                }}
              />
            </div>
            <div className="col-6">
              <InputWrapper /*Тип доставки*/
                label="Тип доставки"
                id="type"
                value={values.type}
                onChange={(e) => setFieldValue('type', e.target.value)}
                isDisabled={true}
              />
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: 'flex-start' }}>
            <div className="col-6">
              <SelectComponent
                label="ФБМ Тип" /*ФБМ Тип*/
                options={fbmTypeOptions}
                value={{
                  value: values.fbmType,
                  label: findFbmTypeElement,
                }}
                onChange={(value) => handleSetFbmType(value)}
                isClearable
                isDisabled={mode === DELIVERY_INFO_MODS.INFO}
                isSearchable
              />
            </div>
            <div className="col-6">
              <Checkbox
                id="fboDeliveryByCactus"
                label="Доставка Кактусом"
                checked={values.fboDeliveryByCactus}
                onChange={(e) => setFieldValue('fboDeliveryByCactus', e.target.checked)}
                disabled={mode === DELIVERY_INFO_MODS.INFO}
                style={{ zIndex: '999' }}
              />
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: 'flex-end' }}>
            <div className="col-6">
              <InputWrapper /*Номер договора*/
                label="Номер договора"
                id="contractNumber"
                value={values.contractNumber}
                onChange={(e) => setFieldValue('contractNumber', e.target.value)}
                isDisabled={mode === DELIVERY_INFO_MODS.INFO}
              />
            </div>
            <div className="col-6">
              <InputWrapper /*Внешний код*/
                label="Внешний код / DLV id"
                id="deliveryCode"
                value={values.deliveryCode}
                onChange={(e) => setFieldValue('deliveryCode', e.target.value)}
                isDisabled={mode === DELIVERY_INFO_MODS.INFO}
              />
            </div>
          </div>
          <br />
          <div className="row" style={{ alignItems: 'flex-end' }}>
            <div className="col-6">
              <InputWrapper /*Кактус id*/
                label="Кактус id"
                id="cactusId"
                value={values.code}
                onChange={(e) => setFieldValue('code', e.target.value)}
                isDisabled={mode === DELIVERY_INFO_MODS.INFO}
              />
            </div>
            <div className="col-6"></div>
          </div>
          <br />
          <div className="row" style={{ alignItems: 'flex-end' }}>
            <div className="col-4">
              <Checkbox
                id="active"
                label="Активен"
                checked={values.active}
                onChange={(e) => setFieldValue('active', e.target.checked)}
                disabled={mode === DELIVERY_INFO_MODS.INFO}
              />
            </div>
            <div className="col-4">
              <Checkbox
                id="publicAvailable"
                label="Виден покупателю"
                checked={values.publicAvailable}
                onChange={(e) => setFieldValue('publicAvailable', e.target.checked)}
                disabled={mode === DELIVERY_INFO_MODS.INFO}
              />
            </div>
            <div className="col-4">
              <Checkbox
                id="marketplace"
                label="ФБС МП"
                checked={values.marketplace}
                onChange={(e) => setFieldValue('marketplace', e.target.checked)}
                disabled={true}
              />
            </div>
          </div>
          <br />
        </div>
      </form>
    </Wrapper>
  );
};

export default Info;
